import React, { Suspense } from 'react'
import { createRoot } from 'react-dom/client'

import 'App.css'

// React 18でのdefaultProps警告を抑制（ライブラリ起因）
const originalConsoleWarn = console.warn;
console.warn = (...args) => {
  if (
    typeof args[0] === 'string' &&
    args[0].includes('defaultProps will be removed from function components')
  ) {
    return;
  }
  originalConsoleWarn.apply(console, args);
};

const App = React.lazy(() => import('./App'))

export const AppLoader = () => (
  <div className='app-loader'>
    {/* <img src={BgImage} /> */}
    <span />
    <p>お待ちください...</p>
  </div>
)

const container = document.getElementById('root')
const root = createRoot(container)
root.render(
  <Suspense fallback={<AppLoader />}>
    <App />
  </Suspense>
)
